import { Injectable } from '@angular/core';
import { SupplierProfile } from '@supoui/shared/model/supplier-profile';
import { Observable, ReplaySubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SupplierProfileStateService {
  private supplierProfilesSubject = new ReplaySubject<SupplierProfile[]>(1);
  private supplierProfilesCachedCaseId: number = null;

  constructor() {}

  public getSupplierProfiles(): ReplaySubject<SupplierProfile[]> {
    return this.supplierProfilesSubject;
  }

  public isSupplierProfilesCached(caseId: string): boolean {
    return this.supplierProfilesCachedCaseId === +caseId;
  }

  public initSupplierProfilesCache(caseId: string): ReplaySubject<SupplierProfile[]> {
    this.supplierProfilesCachedCaseId = +caseId;
    this.supplierProfilesSubject = new ReplaySubject<SupplierProfile[]>(1);
    return this.supplierProfilesSubject;
  }

  public clearCache(): void {
    this.supplierProfilesCachedCaseId = null;
  }

  public emitResponse(response: SupplierProfile[]): void {
    this.supplierProfilesSubject.next(response);
  }

  public emitError(): void {
    this.supplierProfilesSubject.error('Failed to fetch supplier profiles!');
  }
}
